<sirius-grid>
  <div class="sir-container">
    @if (title) {
      <sirius-heading
        data-cy="sirius-heading"
        [text]="title"
        textStyleCategory="title"
        textStyleSize="m">
      </sirius-heading>
    }

    <div class="file-cards">
      @for (downloadedItem of downloadItems; track $index) {
        <commerce-file-download-card
          data-cy="file-download-card"
          [siriusIconName]="getIconName(downloadedItem.fileExtension)"
          [fileTitle]="downloadedItem.title || downloadedItem.link.title"
          [fileDescription]="downloadedItem.description || ''"
                [buttonText]="
                    'commerce.download'
                        | translate : { fileExtension: downloadedItem.fileExtension.toUpperCase() }
                "
          [link]="downloadedItem.link">
        </commerce-file-download-card>
      }
    </div>
  </div>
</sirius-grid>
